import { i18n, Messages } from '@lingui/core'

const messages: Record<string, Messages> = {
  ar: {},
  en: {},
  es: {},
  fr: {},
  it: {},
  pt: {},
}

export type Lang = keyof typeof messages

export async function loadLinguiMessages(lang: string) {
  const key = lang as Lang
  if (messages[key] && Object.keys(messages[key]).length > 0) {
    return messages[key]
  }

  messages[key] = await importMessages(key)
  return messages[key]
}

export async function activateLingui(lang: string) {
  const msgs = await loadLinguiMessages(lang)
  i18n.load(lang, msgs)
  i18n.activate(lang)
}

async function importMessages(lang: Lang) {
  const { messages } = await import(`./locales/${lang}/messages.ts`)
  return messages as Messages
}
